import { render } from "./RedeemInvitePage.vue?vue&type=template&id=1afefb54&ts=true"
import script from "./RedeemInvitePage.vue?vue&type=script&lang=ts"
export * from "./RedeemInvitePage.vue?vue&type=script&lang=ts"

import "./RedeemInvitePage.vue?vue&type=style&index=0&id=1afefb54&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__